
import React, { useState, useEffect } from 'react'
import Dashboard from 'src/views/dashboard/Dashboard'
import { useHistory } from "react-router-dom";
import {
    CNav,
    CNavItem,
    CNavLink,
    CRow,
    CTabContent,
    CTabPane,
    CModal,
    CTabs,
    CModalBody,
    CModalFooter,
    CModalHeader,
    CModalTitle,
    CBadge,
    CDataTable,
    CButton,
    CCard,
    CCardBody,
    CCardFooter,
    CCardHeader,
    CCol,
    CForm,
    CSelect,
    CFormGroup,
    CInputGroupAppend,
    CInputGroup,
    CLabel,
    CInputCheckbox,
    CSwitch,
    CFormText,
    CInput,
    CInputFile
} from '@coreui/react'
import './trainingPopup.css'
import { config } from 'src/utils/apiUrl'
import API from 'src/utils/apiCalling'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const LMSTrainingPopup = (props) => {
    const api = new API()
    const history = useHistory();
    const { isOpen, isViewModalOpen, setIsOpenTrainingPopup, trainingName } = props;

    const onClickViewTraining = () =>{
        history.push(`/dashboard/lms-training`);
        setIsOpenTrainingPopup(false);
    } 

    return (
        <div>
            <CModal
                show={isOpen}
                style={{ background: 'none', border: 'none' }}
                size="lg"
                backdrop="static"
                closeOnBackdrop={false}
                className="custom-backdrop"
            >
                <CModalBody>
                    <div className=" justify-content-center">
                        <div className=" rating_bg1 mt-5">
                            <div className="mt-2 text-center">
                                <h4 className="mb-0" style={{ color: "#6f4e37" }}>Training Pending!</h4>
                                <div className="d-flex flex-row  mt-2">
                                    <div className="modal-body">
                                        <div className="row">
                                            <div className="col-md">
                                                <div>
                                                    <img alt="" src="images/icons/notification.gif" height="90" width="90" style={{ textAlign: "center" }} />
                                                    <div className='text_reting mt-2'>
                                                        <h6>The training <b style={{ color: "coral" }}>{trainingName}</b> is currently pending. We request you to complete it at the earliest to avoid any interruption.</h6>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <hr className='line_rating'></hr>
                                    </div>
                                </div>
                                <div className="mt-2 mr-2">
                                    <button type="button" onClick={() => onClickViewTraining()} className="btn btn-success mb-3 mr-1"><span>View Training</span></button>
                                    <button type="button" onClick={() => setIsOpenTrainingPopup(false)} className="btn btn-danger mb-3"><span>Close</span></button>
                                </div>
                            </div>
                        </div>
                    </div>
                </CModalBody>
            </CModal>

        </div>
    )
}
export default LMSTrainingPopup